import React, {useCallback} from 'react';
import {Box, Button} from '@mui/material';
import {useMsal} from '@azure/msal-react';
import Icon from '@mui/material/Icon';
import Paper from '@mui/material/Paper';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMicrosoft} from '@fortawesome/free-brands-svg-icons';
import CircularProgress from '@mui/material/CircularProgress';
import {msalDefaultRequest} from '../../util/auth';
import Copyright from '../../components/Copyright';
import AppName from '../../components/AppName';
import {useMsalHandleRedirect} from '../../hooks/useMsalHandleRedirect';

const flexCenterAll = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const LogInTemplate = () => {
  const {instance} = useMsal();
  const isHandled = useMsalHandleRedirect();

  const handleLoginRedirect = useCallback(() => {
    instance.loginRedirect(msalDefaultRequest);
  }, [instance]);

  return (
    <Box
      sx={{
        ...flexCenterAll,
        flexDirection: 'column',
        width: '100%',
        height: '100%'
      }}>
      <Box
        sx={{
          mt: 'auto',
          mb: 2,
          ...flexCenterAll
        }}>
        <AppName />
        <Icon
          sx={{
            ml: 2,
            width: '3em',
            height: '3em',
            ...flexCenterAll
          }}>
          {/*<img style={{width: '100%'}} src={hrLogo} alt={getAppName(true)} />*/}
        </Icon>
      </Box>
      <Paper
        sx={{
          p: 8
        }}>
        <Button
          variant={'outlined'}
          startIcon={<FontAwesomeIcon icon={faMicrosoft} />}
          endIcon={!isHandled && <CircularProgress color='inherit' size={20} />}
          onClick={handleLoginRedirect}>
          {/*{!inProgress ? t('auth:loginWithHr') : t('auth:loggingInDots')}*/}
          {isHandled ? 'Log in' : 'Logging in...'}
        </Button>
      </Paper>
      <Box
        sx={{
          width: '100%',
          marginTop: 'auto',
          ...flexCenterAll,
          flexDirection: 'column'
        }}>
        <Copyright />
      </Box>
    </Box>
  );
};
